import React from 'react';
import './AiBox.scss';
import { connect } from 'react-redux';
import * as actions from "store/actions/index";
import { isTranscoder1, isOriginTranscoder1 }
    from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots, faFileImage } from '@fortawesome/free-solid-svg-icons';
import Tesseract from 'Flow2/components/Ai/Tesseract/Tesseract';
import FaceBox from 'Flow2/components/Ai/Faces/FaceBox/FaceBox';
import FaceRecognize from "Flow2/components/Ai/Faces/FaceRecognize/FaceRecognize";
import AiView from "Flow2/components/Ai/AiView/AiView";

class AiBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAiBox: false
        };
    }

    onWhisperClick = () => {
        let clipId = this.props.clip.id;
        if (clipId) this.props.whisperAiObjects({ clipId })
    }


    onTesseractClick = () => {
        const clip = this.props.clip;
        const { aiTesseract } = this.props.aiObjects;
        let ocr;
        if (clip && clip.metadata) {
            if (clip.metadata.ocr) ocr = clip.metadata.ocr;
            else {
                this.props.tesseractAiObjects({ clipId: clip.id });
            }
        }
        this.setState({ showTesseract: true });
        this.props.updateAiObjects({
            aiTesseract: { ...aiTesseract, showOverlay: true, ocr }
        });
    }

    componentDidMount() { }

    showAiBoxButton = () => {
        if (isTranscoder1() || isOriginTranscoder1())
            return (
                <div className="AiBoxButton">
                    <FaceRecognize />
                    <button onClick={this.onWhisperClick}>
                        <FontAwesomeIcon icon={faCommentDots} />
                    </button>
                    <button onClick={this.onTesseractClick}>
                        <FontAwesomeIcon icon={faFileImage} />
                    </button>
                </div>)
    }

    showAiBox = () => {
        if (this.props.isToolbar) {
            return (
                <div className="AiBoxToolbar">
                    <FaceBox />
                    <Tesseract titleIntl="data.ai.tesseract"
                        onlyTest={true} mainObj={this.props.aiObjects} mainObjName="aiObjects"
                        subObjName="aiTesseract" updatePopUpObjects={this.props.updateAiObjects} />
                </div>)
        }
        return this.showAiBoxButton();
    }


    render() {
        if (isTranscoder1() || isOriginTranscoder1()) {
            if (this.props.isFaces) return <AiView isFaces={true} />
            if (this.props.isOcr) return <AiView isOcr={true} />

            return (
                <div className="AiBox">
                    {this.showAiBox()}
                </div>)
        }
        return null;
    }
}

const mapStateToprops = (state) => ({
    aiObjects: state.ai.aiObjects,
    clip: state.clip.currentClip,
})

const mapDispatchToProps = (dispatch) => ({
    updateAiObjects: (obj) => dispatch(actions.updateAiObjects(obj)),
    detectAiObjects: (obj) => dispatch(actions.detectAiObjects(obj)),
    whisperAiObjects: (obj) => dispatch(actions.whisperAiObjects(obj)),
    tesseractAiObjects: (obj) => dispatch(actions.tesseractAiObjects(obj))
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(AiBox));